import { selectedWebhookData, webhookModal } from "../redux/kyc/generalSlice";
import { useDispatch, useSelector } from "react-redux";
import { formatDate } from "../utils/Dateformat";
import { MdOutlineClose } from "react-icons/md";
import { BackDrop } from "./BackDrop";
import { fetchwebhookevent, geteventStatistic, sendWebhook } from "../redux/webhookEvents/webhookeventSlice";
import { getUserState } from "../redux/authentication/getUserSlice";

export const WebhookModal = () => {
	const data = useSelector((state) => state.general.webhookData);
	const dispatch = useDispatch();
const { activeBusiness } = useSelector(getUserState);

	const closeTransModal = () => {
		dispatch(webhookModal(false));
		dispatch(selectedWebhookData(null));
	};

	const pushwebhook = async () => {
	
		const res = await dispatch(
			sendWebhook({
				businessid: activeBusiness?.id,
				webhook_ids: [data.id],
			}),
		);
		closeTransModal()

		if (res?.meta.requestStatus === "fulfilled") {
			dispatch(
				fetchwebhookevent({
					businessid: activeBusiness?.id,
				}),
			);

			dispatch(geteventStatistic({ businessid: activeBusiness?.id }));
		}
		
	};



	return (
		<BackDrop>
			<div className="modal">
				<div className="header">
					
					<div
						className="close-icon"
						onClick={() => closeTransModal()}
					>
						<MdOutlineClose
							size={20}
							color="#fff"
						/>
					</div>

				</div>
				<div className="body-trans">

					<div className="trans-data mb-4" >
					<button
						className="btn btn-prm"
						onClick={() => pushwebhook()}
					>
						repush
					</button>
				</div>

				
					{data && (
						<>
							<div className="trans-data">
								<div>Date:</div>
								<div>{formatDate(data.created_date)}</div>
							</div>

							<div className="trans-data">
								<div>Reference:</div>
								<div>{data.reference}</div>
							</div>

							<div className="trans-data">
								<div>Session ID:</div>
								<div>{data.reference}</div>
							</div>

							<div className="trans-data">
								<div>Attempt:</div>
								<div>{data.attempts}</div>
							</div>

							<div className="trans-data">
								<div>Webhook Url:</div>
								<div>{data.url}</div>
							</div>

							<div className="trans-data">
								<div>Request Time:</div>
								<div>{formatDate(data.request_time)}</div>
							</div>

							<div className="trans-data code-section">
								<div>Request Payload:</div>
								<div>
									{String(
										JSON.parse(JSON.stringify(data.data)),
									)}
								</div>
							</div>

							<div className="trans-data">
								<div>Status:</div>
								<div className="trans-status">
									<span
										className={
											data.status === "sent"
												? "btn-success "
												: data.status === "failed"
												? "btn-danger"
												: "btn-warn"
										}
									>
										{data.status}
									</span>
								</div>
							</div>

							<div className="trans-data code-section">
								<div>Response Body:</div>
								<div>{data.response_message}</div>
							</div>

							<div className="trans-data">
								<div>Response Time:</div>
								<div>{formatDate(data.response_time)}</div>
							</div>
							<div className="trans-data">
								<div>Response Code:</div>
								<div>{data.response_code}</div>
							</div>
						</>
					)}
				</div>

				<div className="flex justify-between items-center">
				<div className="btn-trans-close">
					<button
						className="btn btn-prm"
						onClick={() => closeTransModal()}
					>
						Close
					</button>
				</div>

					
				</div>
			</div>
		</BackDrop>
	);
};
